module.exports = __webpack_public_path__ + "img/APnet.b51f1cb4.jpg";